export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Egypt-6033ad94b4409f4a087ad61f4d6b6396.mp3";